import request from '@/utils/request'


export function addDistribution(data) {
    return request({
        url: `api/serviceCenter/distribution/addDistribution`,
        method: 'post',
        data,
    })
}

export function upDateDistribution(data) {
    return request({
        url: `api/serviceCenter/distribution/upDateDistribution`,
        method: 'post',
        data,
    })
}

export function TransactionSelectInfo(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/transaction/TransactionSelectInfo?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}

export function bathDeleteDistribution(data) {
    return request({
        url: `api/serviceCenter/distribution/bathDeleteDistribution`,
        method: 'post',
        data,
    })
}


export function bathDelete(data) {
    return request({
        url: `api/serviceCenter/transaction/bathDelete`,
        method: 'post',
        data,
    })
}



